import { render, staticRenderFns } from "./m-roster-upload.vue?vue&type=template&id=d27a978c&scoped=true&"
import script from "./m-roster-upload.ts?vue&type=script&lang=ts&"
export * from "./m-roster-upload.ts?vue&type=script&lang=ts&"
import style0 from "./m-roster-upload.scss?vue&type=style&index=0&id=d27a978c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27a978c",
  null
  
)

export default component.exports